module.exports = __webpack_public_path__ + "src/assets/guide/chronos-filters.gif";